
export const PAGE_WIDTH_MM = 297;
export const PAGE_HEIGHT_MM = 210;
export const PAGE_MARGIN_MM = 10;
export const PAGE_HEADER_HEIGHT_MM = 18;
export const PAGE_FOOTER_CLEARANCE_MM = 8;

export const PX_TO_MM = 25.4 / 96;

export const BASE_CAPTURE_SCALE = 2;

/** Fixed CSS viewport for every capture, so media queries do not follow the live window or zoom. */
export const EXPORT_CAPTURE_WIDTH_PX = 1440;
export const EXPORT_CAPTURE_MIN_HEIGHT_PX = 1200;

export const MAX_CANVAS_DIMENSION_PX = 16000;

export const TARGET_CHUNK_HEIGHT_CSS_PX = 4000;
